import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const selfCheck = z.object({
  failed: z.boolean().default(false),
  finishedAt: z.date().default(() => new Date()),
  results: z.array(
    z.object({
      check: z.boolean(),
      id: z.string(),
      result: z.boolean(),
      text: z.string(),
    }),
  ),
  fairMode: z.boolean().default(false),
});

export class SelfCheck extends createZodDto(selfCheck) {}
